// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JobTasksTable_root__Q2dpX {
  display: flex;
  flex-direction: column;
  padding: 16px 0;
}
.JobTasksTable_root__Q2dpX .JobTasksTable_header__zamsj {
  padding: 0 24px;
  font-size: 20px;
  font-weight: 300;
  color: #111111;
}
.JobTasksTable_root__Q2dpX thead th {
  font-size: 10px;
  line-height: 24px;
  color: #111111;
  text-wrap: nowrap;
}
.JobTasksTable_root__Q2dpX tbody td {
  font-size: 10px;
  color: rgba(17, 17, 17, 0.6392156863);
  letter-spacing: 0.1px;
  text-transform: capitalize;
  vertical-align: middle;
}
.JobTasksTable_root__Q2dpX tbody tr.JobTasksTable_active__V8-fW td {
  background-color: #f2f2f2;
}
.JobTasksTable_root__Q2dpX .JobTasksTable_actions__79fi0 {
  display: flex;
  gap: 8px;
}
.JobTasksTable_root__Q2dpX .JobTasksTable_actions__79fi0 svg {
  cursor: pointer;
}
.JobTasksTable_root__Q2dpX .JobTasksTable_actions__79fi0 svg.JobTasksTable_disabled__YBYbf {
  cursor: default;
}
.JobTasksTable_root__Q2dpX .JobTasksTable_hideSelectionColumn__4Y05s tr > :first-child {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/JobTasksTable/JobTasksTable.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AACF;AAAE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAEJ;AAAE;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;AAEJ;AAAE;EACE,eAAA;EACA,qCAAA;EACA,qBAAA;EACA,0BAAA;EACA,sBAAA;AAEJ;AAAE;EACE,yBAAA;AAEJ;AAAE;EACE,aAAA;EACA,QAAA;AAEJ;AADI;EACE,eAAA;AAGN;AAFM;EACE,eAAA;AAIR;AAEI;EACE,aAAA;AAAN","sourcesContent":[".root {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 16px 0;\r\n  .header {\r\n    padding: 0 24px;\r\n    font-size: 20px;\r\n    font-weight: 300;\r\n    color: #111111;\r\n  }\r\n  thead th {\r\n    font-size: 10px;\r\n    line-height: 24px;\r\n    color: #111111;\r\n    text-wrap: nowrap;\r\n  }\r\n  tbody td {\r\n    font-size: 10px;\r\n    color: #111111A3;\r\n    letter-spacing: 0.1px;\r\n    text-transform: capitalize;\r\n    vertical-align: middle;\r\n  }\r\n  tbody tr.active td {\r\n    background-color: #f2f2f2;\r\n  }\r\n  .actions {\r\n    display: flex;\r\n    gap: 8px;\r\n    svg {\r\n      cursor: pointer;\r\n      &.disabled {\r\n        cursor: default;\r\n      }\r\n    }\r\n  }\r\n\r\n  .hideSelectionColumn {\r\n    tr > :first-child {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `JobTasksTable_root__Q2dpX`,
	"header": `JobTasksTable_header__zamsj`,
	"active": `JobTasksTable_active__V8-fW`,
	"actions": `JobTasksTable_actions__79fi0`,
	"disabled": `JobTasksTable_disabled__YBYbf`,
	"hideSelectionColumn": `JobTasksTable_hideSelectionColumn__4Y05s`
};
export default ___CSS_LOADER_EXPORT___;
